import { render } from "./LayoutStart.vue?vue&type=template&id=584bfda6"
import script from "./LayoutStart.vue?vue&type=script&lang=js"
export * from "./LayoutStart.vue?vue&type=script&lang=js"

import "./LayoutStart.vue?vue&type=style&index=0&id=584bfda6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__